import { Injectable, Injector } from '@angular/core'

import { HttpInterceptorService } from 'api/module'
import { DummyInterface } from 'panel/interfaces/dummy'
import { ResolvePanelInterface } from 'panel/interfaces/resolve'
import { CEPPanelInterface } from 'panel/interfaces/cep'
import { BaseInterface } from 'panel/interfaces/base'

interface PanelWindow extends Window {
  cep?: any
  nodeRequire?: any
  WorkflowIntegration?: any
  dummyPanelInterface?: any
}
declare let window: PanelWindow

@Injectable({ providedIn: 'root' })
export class PanelService {
  plugin: BaseInterface
  ready: Promise<void>
  platform: string
  native = false
  active = false
  app: string
  fs: any

  constructor (
    private injector: Injector,
    private interceptor: HttpInterceptorService,
  ) {
    this.plugin = new DummyInterface(injector)

    if (typeof window.cep !== typeof undefined) {
      this.plugin = new CEPPanelInterface(injector)
    } else if (typeof window.WorkflowIntegration !== typeof undefined) {
      this.plugin = new ResolvePanelInterface(injector)
    }

    this.native = this.plugin.native
    this.app = this.plugin.getApp()
    this.fs = this.plugin.getFS()
    this.platform = this.plugin.getPlatform()

    this.ready = this.plugin.init()
    this.ready.then(() => {
      this.active = this.plugin.active
      if (this.active) {
        this.interceptor.enableSessionExpiryDetection = false
        this.interceptor.sessionExpired$.subscribe(() => {
          if (this.native) {
            this.restartExtension()
          }
        })
      }
    })
  }

  restartExtension (): void {
    this.plugin.restart()
  }
}
